import { render, staticRenderFns } from "./FixitDialog.vue?vue&type=template&id=4bcb1f6e"
import script from "./FixitDialog.vue?vue&type=script&lang=js"
export * from "./FixitDialog.vue?vue&type=script&lang=js"
import style0 from "./FixitDialog.vue?vue&type=style&index=0&id=4bcb1f6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports